let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8brer")).then(() => parcelRequire('i5FAK'));